import { Component, OnInit, Input, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { AttachmentService } from '../services/attachment.service';

@Component({
  selector: 'app-dynamic-property',
  templateUrl: './dynamic-property.component.html',
  styleUrls: ['./dynamic-property.component.css']
})
export class DynamicPropertyComponent implements OnInit, OnDestroy {

  htmlContent: string;
  private type: string;
  private fileId: string;
  private eventInstance: () => void;

  constructor(private renderer: Renderer2, private elRef: ElementRef, private attachmentService: AttachmentService) { }

  ngOnInit() {
  }

  ngOnDestroy(){
    if (this.eventInstance){
      this.eventInstance();
    }
  }

  @Input() set setHTML(html: string){
    if (html.indexOf("{") > -1){
      var re = new RegExp(/{(.*?)}/);
      var reString = re.exec(html);
      if (reString){
        if (reString.length > 0){
          this.type = reString[1].split(':')[0];
          if (this.type){
            switch(this.type.toUpperCase()){
              case "FILE":
                var displayValue = reString[1].split(':')[1];
                this.fileId = reString[1].split(':')[2];
      
                this.htmlContent = html.replace(re, "<span class='listen-element'>" + displayValue + "</span>");
                break;
              case "WORKFLOW":
                break;
            }
            
          }
        }
      }
    }
    else{
      this.htmlContent = html;
    }
  }

  afterInit(){
    setTimeout(() => {
      if (this.elRef.nativeElement.querySelector('.listen-element')){
        if (this.eventInstance) {
          this.eventInstance();
        }

        this.eventInstance = this.renderer.listen(this.elRef.nativeElement.querySelector('.listen-element'), 'click', () => {
          this.downloadFixedFile()
        });
      }
    })
  }

  downloadFixedFile(){
    this.attachmentService.downloadFile(this.fileId).subscribe(data=>{
      this.attachmentService.getFileName(this.fileId).subscribe(result => {
        var fileName = "file";
        fileName = result;
        this.downloadFile(data, fileName);
      })
      
    });
  }

  downloadFile(blob: any, fileName:string): void {
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();        

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }
}
